<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logos/logo-ontrix-original.png";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);
</script>
<template>
  <div
    v-show="layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${darkMode ? 'bg-transparent' : 'bg-success'}`"
  />

  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="`${isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'}    
      ${
        layout === 'landing' ? 'bg-transparent shadow-none' : ' '
      } ${sidebarType}`"
    id="sidenav-main"
  >
  <router-link  to="/dashboard">
    <div class="d-flex justify-content-center align-items-center p-2" >
     
        <img
          :src="logo"
         style="width: 70%;padding: 15px;"
        />
        <!-- <span class="ms-2 font-weight-bold me-2">BIENVENIDO</span> -->
     
    </div>

  </router-link>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list />
  </aside>
</template>

